import React from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../utils/useFetch';
import BusinessInformation from '../components/updateProfile/BusinessInformation';

const BusinessInformationPage = () => {
    const { user } = useSelector((state) => state.user);
    const { data, loading, error } = useFetch(`system/users/${user?.user?.uuid}/`);

    return (



        <div >
            {loading ? (
                <div className="text-center py-10">
                    <div className="spinner-border text-brand-500" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : error ? (
                <div className="text-center py-10 text-red-500">
                    Failed to load business information
                </div>
            ) : (
                <div className="max-w-3xl mx-auto">
                    <BusinessInformation data={data} />
                </div>
            )}
        </div>

    );
};

export default BusinessInformationPage; 